import { auth } from "auth"
import * as env from "../env"

export const initializeAppLauncher = async () => {
  const { accessToken, subdomain, companyNameKey } =
    await auth.getActiveSession()

  // TODO: Remove once accestoken always is a string
  const accessTokenAsString = String(accessToken)

  const { initAppLauncher } = await import("@attensi/app-launcher")

  initAppLauncher({
    env: env.APP_ENV,
    apiUrl: env.BACKOFFICE_API_URL,
    authUrl: env.AUTH_URL,
    apiToken: env.API_TOKEN,
    accessToken: accessTokenAsString,
    subdomain,
    companyNameKey,
  })
}
